<template>
    <div class="step-two-container">
        <div class="title">
            <span>
                {{ $t('intervention.steptwo.label.type') }}
            </span>
        </div>
        <DropDown
            :display="diplayType"
            :label="$t('intervention.steptwo.label.type')"
            :list="types"
            :selectedItem="selectedType"
            class="width"
            @select="selectType"
        />
        <div class="title title-delai">
            <span>
                {{ $t('intervention.steptwo.label.delai') }}
            </span>
            <ReglePastille cle="demandeIntervention.delaiIntervention" />
        </div>
        <DropDown
            :display="diplayType"
            :label="$t('intervention.steptwo.label.delai')"
            :list="selectedType ? selectedType.delais : []"
            :selectedItem="selectedDelai"
            class="width"
            @select="selectDelai"
        />
        <div class="width">
            <DatePicker
                v-if="selectedDelai && selectedDelai.isAutre"
                :dateMin="dateNow"
                :dateValue="dateAutre"
                :label="$t('intervention.other.date')"
                @setDate="setDateAutre"
            />
        </div>
    </div>
</template>

<script lang="ts">
import DatePicker from '@/components/ui-components/DatePicker.vue';
import DropDown from '@/components/ui-components/DropDown.vue';
import { Delai } from '@/models/Delai';
import { Site } from '@/models/Site';
import { TypeItems } from '@/models/TypeItems';
import { defineComponent } from 'vue';
import dayjs from 'dayjs';
import { TypeActions } from '../store/modules/Types';
import { INTERVENTION } from '../store/mutation-types';
import ReglePastille from '@/components/regles/ReglePastille.vue';

export default defineComponent({
    data() {
        return {
            dateFocus: false,
        };
    },
    mounted() {
        this.$store.dispatch(`typeModule/${TypeActions.GET_TYPE}`, this.selectedSite.chantierId);
    },
    components: { DropDown, DatePicker, ReglePastille },
    methods: {
        diplayType(item: TypeItems) {
            return item.libelle;
        },
        selectType(type: TypeItems) {
            this.$store.commit(INTERVENTION.SET_TYPE, type);
        },
        selectDelai(delai: Delai) {
            if (!delai.isAutre) this.$store.commit(INTERVENTION.SET_DATE_AUTRE, '');
            this.$store.commit(INTERVENTION.SET_DELAI, delai);
        },
        setDateAutre(date: string) {
            this.$store.commit(INTERVENTION.SET_DATE_AUTRE, date);
        },
    },
    computed: {
        selectedSite(): Site {
            return this.$store.getters.getInterventionSiteValue;
        },
        types(): TypeItems[] {
            const types: TypeItems[] = this.$store.getters['typeModule/getTypeList'];
            if (types !== undefined && types.length === 1) {
                this.selectType(types[0]);
                if (types[0].delais.length === 1) {
                    this.selectDelai(types[0].delais[0]);
                }
            }
            return types;
        },
        selectedType(): TypeItems {
            return this.$store.getters.getInterventionTypeValue;
        },
        selectedDelai(): TypeItems {
            return this.$store.getters.getInterventionDelaiValue;
        },
        calendarIcon() {
            return require('@/assets/img/calendar.svg');
        },
        dateAutre() {
            return this.$store.getters.getInterventionDateAutreValue;
        },
        dateNow() {
            return dayjs().format('YYYY-MM-DD');
        },
    },
});
</script>

<style scoped>
.step-two-container {
    padding: 24px;
    background-color: var(--white);
    border-radius: 4px;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 1px 5px rgba(0, 0, 0, 0.12);
}
.title {
    font-weight: 500;
    font-size: var(--font-size-low-medium);
    color: var(--dark-grey);
    margin-bottom: 8px;
}
.title-delai {
    margin-top: 8px;
}

.title-delai + .input-container {
    margin-bottom: 8px;
}

.width {
    width: 500px;
}
</style>
